export default __webpack_public_path__ + "static/media/passengers.c8cb5530.svg";